module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page3.b7603fd9.jpg";